import React, { useEffect, useState } from "react";
import Table from "../../../../common/element/Table";
import Button from "../../../../common/element/Buttons";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import AddEditIndividual from "./AddEdit";
import ArchiveModal from "../../../../common/Common/ArchiveModal";
import DeleteModal from "../../../../common/Common/DeleteModal";
import ThreeDotBouncingLoader from "../../../../common/element/ButtonLoader/ThreeDotBouncingLoder";
import { archiveScienceOfSelf, clearArchiveScienceOfSelf, getScienceOfSelfList, deleteScienceOfSelf, clearDeleteScienceOfSelf } from "../../../../redux/ScienceOfSelf/Scienceofselfslice";
import { setScienceOfSelfName } from "../../../../redux/Admin/scienceOfSelfViewSlice";
import { selectArchiveScienceOfSelfData, selectArchiveScienceOfSelfLoading, selectArchiveScienceOfSelfError, selectDeleteScienceOfSelfData, selectDeleteScienceOfSelfLoading, selectDeleteScienceOfSelfError } from "../../../../redux/ScienceOfSelf/Scienceofselfselectors";
import SweetAlertService from "../../../../common/SweetAlert/SweetAlert";
import moment from "moment/moment";
import CommonIconButton from "../../../../common/icons/CommonIconButton";

const { Tr, Th, Td, THead, TBody } = Table;

const ScienceOfSelfList = ({ sampleData, loading, onRefresh }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [dialogOpen, setDialogOpen] = useState(false);
  const [selectedIndividual, setSelectedIndividual] = useState(null);
  const [isViewMode, setIsViewMode] = useState(false);
  const [isDeleteOpen, setIsDeleteOpen] = useState(false);
  const deleteData = useSelector(selectDeleteScienceOfSelfData);
  const deleteLoading = useSelector(selectDeleteScienceOfSelfLoading);
  const deleteError = useSelector(selectDeleteScienceOfSelfError);
  const handleDeleteClick = (item) => {
    setSelectedIndividual(item);
    setIsDeleteOpen(true);
  };

  const handleDeleteConfirm = () => {
    if (selectedIndividual) {
      dispatch(deleteScienceOfSelf(selectedIndividual.id));
    }
  };

  useEffect(() => {
    if (deleteData) {
      SweetAlertService.showSuccess({
        title: "Success!",
        message: deleteData?.message || "Record deleted successfully",
        onConfirm: () => {
          dispatch(clearDeleteScienceOfSelf());
          if (onRefresh) onRefresh();
          setIsDeleteOpen(false);
          setSelectedIndividual(null);
        }
      });
    }
  }, [deleteData, dispatch, onRefresh]);

  useEffect(() => {
    if (deleteError) {
      SweetAlertService.showError({
        title: "Error!",
        message: deleteError || "Failed to delete record",
      });
      dispatch(clearDeleteScienceOfSelf());
    }
  }, [deleteError, dispatch]);

  return (
    <>
      <div className="border rounded-lg border-gray-200">
        <Table>
          <THead>
            <Tr>
              <Th className="font-lato font-medium text-sm leading-[1.5] text-[#475467]">S No.</Th>
              <Th className="font-lato font-medium text-sm leading-[1.5] text-[#475467]">Name</Th>
              <Th className="font-lato font-medium text-sm leading-[1.5] text-[#475467]">Email</Th>
              <Th className="font-lato font-medium text-sm leading-[1.5] text-[#475467]">State</Th>

              <Th className="font-lato font-medium text-sm leading-[1.5] text-[#475467]">City</Th>
              <Th className="font-lato font-medium text-sm leading-[1.5] text-[#475467]">Date </Th>
              {/* <Th className="font-lato font-medium text-sm leading-[1.5] text-[#475467]">Date & Time</Th> */}
              <Th className="font-lato font-medium text-sm leading-[1.5] text-[#475467]">Action</Th>
            </Tr>
          </THead>

          <TBody>
            {loading ? (
              <Tr>
                <Td colSpan={7} className="py-10 text-center">
                  <ThreeDotBouncingLoader />
                </Td>
              </Tr>
            ) : sampleData.length > 0 ? (
              sampleData.map((item, index) => (
                <Tr key={item.id} className="text-start">
                  <Td className="text-start">{String(index + 1).padStart(2, "0")}</Td>
                  <Td className="text-start">{item.user?.first_name} {item.user?.last_name}</Td>
                  <Td className="text-start">{item.user?.email}</Td>
                  <Td className="text-start">{item.state?.state_name || "-"}</Td>

                  <Td className="text-start">{item.city?.city_name || "-"}</Td>
                  <Td className="text-start">{item.created_at ? moment(item.created_at).format("DD/MM/YYYY") : "-"}</Td>
                  <Td className="text-start">
                    <div className="flex gap-1">
                      {/* View Button */}
                      <CommonIconButton
                      type="view"  onClick={() => {
                        const fullName = `${item.user?.first_name || ''} ${item.user?.last_name || ''}`.trim();
                        dispatch(setScienceOfSelfName(fullName));
                        navigate(`/scienceOfSelf/view?id=${item.id}`);
                      }}/>
                      

                      {/* Edit Button */}
                      <CommonIconButton
                      type="edit"
                        onClick={() => {
                          setSelectedIndividual(item);
                        setDialogOpen(true);
                        setIsViewMode(false);
                      }}/>
                        

                      {/* Delete Button */}
                      <CommonIconButton
                        type="delete"
                        onClick={() => handleDeleteClick(item)}
                      />
                        


                    </div>
                  </Td>
                </Tr>
              ))
            ) : (
              <Tr>
                <Td colSpan={7} className="text-center font-lato font-medium text-sm leading-[1.5] text-[#1D2939] py-6">
                  No matching records found
                </Td>
              </Tr>
            )}
          </TBody>
        </Table>
      </div>

      <AddEditIndividual
        dialogOpen={dialogOpen}
        onDialogClose={() => {
          setDialogOpen(false);
          setIsViewMode(false);
        }}
        individualData={selectedIndividual}
        isViewMode={isViewMode}
        isEdit={!!selectedIndividual}
      />


      <DeleteModal
        dialogOpen={isDeleteOpen}
        onDialogClose={() => {
          setIsDeleteOpen(false);
          setSelectedIndividual(null);
        }}
        onConfirm={handleDeleteConfirm}
        title="Are you sure you want to delete this record?"
        subtitle={`Deleting "${selectedIndividual?.user?.first_name || ''} ${selectedIndividual?.user?.last_name || ''}" is permanent. Proceed?`}
      />
    </>
  );
};

export default ScienceOfSelfList;